import { render, staticRenderFns } from "./noBankPop.vue?vue&type=template&id=666bb862&"
import script from "./noBankPop.vue?vue&type=script&lang=js&"
export * from "./noBankPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports